import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { INomenclature } from '../interfaces';
import { getNomenclatureList } from '../api';

export function useGetNomenclatures(onLoad?: (data: INomenclature[]) => void) {
  const [{ loading, data, error }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: INomenclature[];
  }>({ loading: false, error: null, data: [] });

  const fetchNomenclatures = async () => {
    setData((prevState) => ({ ...prevState, loading: true }));

    try {
      const response = await getNomenclatureList();
      setData((prevState) => ({ ...prevState, data: response }));
      onLoad?.(response);
    } catch (error) {
      setData((prevState) => ({
        ...prevState,
        data: [],
        error: (error as AxiosError).response?.data.message,
      }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect(() => {
    fetchNomenclatures();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, data, error, fetchNomenclatures };
}
